import { render, staticRenderFns } from "./AudienceTable.vue?vue&type=template&id=79d97882"
import script from "./AudienceTable.vue?vue&type=script&lang=js"
export * from "./AudienceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports